import { render, staticRenderFns } from "./CollateForm.vue?vue&type=template&id=56cab410&"
import script from "./CollateForm.vue?vue&type=script&lang=js&"
export * from "./CollateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports